<app-order-price-list-custom-item-modal></app-order-price-list-custom-item-modal>
<app-order-add-grade></app-order-add-grade>
<app-order-material-uplift></app-order-material-uplift>
<app-order-price-list-add-item [account]='this.account' [site]='this.site'></app-order-price-list-add-item>

@if (this.existingOrders.length > 0) {
  <span style="color:red;font-weight:bold">Please note existing accepted orders exist on the system for this account and site</span><br /><br />
  <table class="table">
    <thead>
      <tr>
        <th>Order Number</th>
        <th>Account</th>
        <th>Site</th>
        <th>Tip Site</th>
        <th>Description</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (order of this.existingOrders; track order) {
        <tr>
          <td>{{ order.id }}</td>
          <td>{{ order.account.name }}</td>
          <td>{{ order.site.name }}</td>
          <td>{{ order.tipSite.name}}</td>
          <td>{{ order.description }}</td>
          <td><button class='btn btn-warning' [routerLink]="'/orders/edit/' + order.id">View Order</button></td>
        </tr>
      }
    </tbody>
  </table>
}

<app-tabs>
  <app-tab title='Main Details' [invalid]="!this.isTabComplete('main')">
    <p>@if (this.order.id !== -1) {
      <button class='btn btn-primary' type='button' [routerLink]='"/orders/change/"+ this.order.id +"/accounts/"'>Edit Customer & Site</button>
    }</p>
    <br />

    <div class='form-row'>
      <div class="form-group col-md-4">
        <label>From Time</label>
        <input (keyup)='setTimeBasedOnRange()' [(ngModel)]='this.fromTime' type="time" name='name' class="form-control" [disabled]="['AM', 'PM', this.getAnyTimeOption()].indexOf(this.order.time) !== -1">
      </div>

      <div class="form-group col-md-4">
        <label>To Time</label>
        <input (keyup)='setTimeBasedOnRange()' [(ngModel)]='this.toTime' type="time" name='name' class="form-control" [disabled]="['AM', 'PM', this.getAnyTimeOption()].indexOf(this.order.time) !== -1">
      </div>

      <div class="form-group col-md-4">

        <input type='radio' name='group[]' value='1' [checked]="['AM', 'PM', getAnyTimeOption()].indexOf(this.order.time) === -1" (change)='onTimeOptionClicked($event)'/><label>Time Window</label>
        <input type='radio' name='group[]' value='AM' [checked]='this.order.time === "AM"' (change)='onTimeOptionClicked($event)'/><label>AM</label>
        <input type='radio' name='group[]' value='PM' [checked]='this.order.time === "PM"' (change)='onTimeOptionClicked($event)'/><label>PM</label>
        <input type='radio' name='group[]' [value]='getAnyTimeOption()' [checked]='this.order.time === getAnyTimeOption()' (change)='onTimeOptionClicked($event)' /><label>{{ this.getAnyTimeOption() }}</label>
      </div>
    </div>


    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Date</label>
        <input type="date" name='name' [(ngModel)]='this.order.date' [class.is-invalid]='!this.order.date' class="form-control">
      </div>

      <div class="form-group col-md-4">
        <label>PO Number <button class='btn btn-primary' type='button' (click)='this.copyPOToSite()'>Copy to Site</button></label>
        <input type="text" name='name' [(ngModel)]='this.order.poNumber' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Order Number</label>
        <input type="text" name='name' [(ngModel)]='this.order.orderNumber' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Collection Number</label>
        <input type="text" name='name' [(ngModel)]='this.order.collectionNumber' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Unique Reference Number</label>
        <input type="text" name='name' [(ngModel)]='this.order.uniqueReference' class="form-control">
      </div>

      <div class="form-group col-md-4">
        <label>Order Type</label>
        <select class='form-control' [class.is-invalid]='this.order.orderTypeId === -1' (change)='this.updateOrderDetails($event)'>
          <option value='-1'>Select a order type</option>
          @for (item of this.types; track item) {
            <option [value]='item.id' [selected]='this.order.orderTypeId === item.id'>{{ item.name }}</option>
          }
        </select>
      </div>
      <div class="form-group col-md-4" [hidden]='this.order.orderTypeId !== 8'>
        <label>Contract</label>
        <select class='form-control' (change)='this.order.contractId = +$event.target.value;'>
          <option value='-1'>Select a contract</option>
          @for (item of this.contracts; track item) {
            <option [value]='item.id' [selected]='item.id === this.order.contractId'>{{ item.name }}</option>
          }
        </select>
      </div>
      <!-- if skip order then select skip order type -->
      @if (this.order.orderTypeId === 1) {
        <div class="form-group col-md-4">
          <label>Skip Order Type</label>
          <select class='form-control' [class.is-invalid]='this.order.skipOrderTypeId === -1' (change)='this.order.skipOrderTypeId = +$event.target.value; this.order.skipOrderType.id = this.order.skipOrderTypeId'>
            <option value='-1'>Select a skip order type</option>
            @for (item of this.skipOrderTypes; track item) {
              <option [value]='item.id' [selected]='this.order.skipOrderTypeId === item.id'>{{ item.name }}</option>
            }
          </select>
        </div>
      }
      <!-- if skip order then select skip order type -->
      @if (this.order.orderTypeId === 8) {
        <div class="form-group col-md-4">
          <label>Shredder Order Type</label>
          <select class='form-control' [class.is-invalid]='this.order.shredderOrderTypeId === -1' (change)='this.order.shredderOrderTypeId = +$event.target.value; this.order.shredderOrderType.id = this.order.shredderOrderTypeId'>
            <option value='-1'>Select a shredder order type</option>
            @for (item of this.shredderTypes; track item) {
              <option [value]='item.id' [selected]='this.order.shredderOrderTypeId === item.id'>{{ item.name }}</option>
            }
          </select>
        </div>
      }

      @if (this.order.orderTypeId === 1) {
        <div class="form-group col-md-4">
          <label>Container Size</label>
          <select class='form-control' [class.is-invalid]='this.order.containerSizeTypeId === -1' (change)='this.order.containerSizeTypeId = +$event.target.value; this.order.containerSizeType.id = this.order.containerSizeTypeId;'>
            <option value='-1'>Select a container size</option>
            @for (item of this.containerSizes; track item) {
              @if (item.vehicleTypeId === 1 || item.vehicleTypeId === 2) {
                <option [value]='item.id' [selected]='this.order.containerSizeTypeId === item.id'>{{ item.size + ' ' + item.unit.name }}</option>
              }
            }
          </select>
        </div>
      }
      @if (this.order.orderTypeId === 1 || this.order.orderTypeId === 8) {
        <div class="form-group col-md-4">
          <label>Container type</label>
          <select class='form-control' [class.is-invalid]='this.order.containerTypeId === -1' (change)='this.order.containerTypeId = +$event.target.value; this.order.containerType.id = this.order.containerTypeId;'>
            <option value='-1'>Select a container type</option>
            @for (item of this.containerTypes; track item) {
              <option [hidden]='((item.name.toLowerCase() === "bag" || item.name.toLowerCase() === "cabinet") && this.order.orderTypeId !== 8) || ((item.name.toLowerCase() !== "bag" && item.name.toLowerCase() !== "cabinet") && this.order.orderTypeId === 8)' [value]='item.id' [selected]='this.order.containerTypeId === item.id'>{{ item.name }}</option>
            }
          </select>
        </div>
      }
      <div class="form-group col-md-4">
        <label>Grade</label>
        <ng-select [(ngModel)]="this.order.gradeId" class='form-control' [class.is-invalid]='this.order.gradeId === -1' (change)='this.order.gradeId = +$event; this.order.grade = {}; this.order.grade.id = this.order.gradeId;'>
          @for (item of this.grades; track item) {
            <ng-option [value]='item.id' [selected]='this.order.gradeId === item.id'>{{ item.name }}@if (item.ewcCodes && item.ewcCodes !== "") {
              ({{ item.ewcCodes }})
            }</ng-option>
          }
        </ng-select>
        <button class='btn btn-primary' type='button' (click)='this.openModal("orderAddGradeModal");'>+ Add grade</button>
      </div>
      @if (this.order.orderTypeId === 3 || this.order.orderTypeId === 4) {
        <div class="form-group col-md-4">
          <label>Tip fee (if zero fee is not required)</label>
          <input type="number" name='name' [(ngModel)]='this.order.tipFee' class="form-control">
        </div>
      }
      @if ((this.order.orderTypeId === 3 || this.order.orderTypeId === 4) && this.order.tipFee > 0) {
        <div class="form-group col-md-4">
          <label>Tip unit</label>
          <select class='form-control' (change)='this.order.tipUnitId = +$event.target.value'>
            @for (item of this.units; track item) {
              <option [selected]='item.id === this.order.tipUnitId' [value]='item.id'>{{ item.name }}</option>
            }
          </select>
        </div>
      }
      <div class="form-group col-md-12">
        <label for="inputPassword4">Description </label>
        <textarea name='notes' [(ngModel)]='this.order.description' class="form-control"></textarea>
      </div>
      <div class="form-group col-md-12">
        <label for="inputPassword4">Driver Notes </label>
        <textarea name='notes' [(ngModel)]='this.order.driverNotes' class="form-control"></textarea>
      </div>
    </div>

    <br />
    <br />

    @if (this.order.id === -1) {
      @if (!this.isRepeat) {
        <button class='btn btn-primary' (click)='this.isRepeat = true'>Select additional dates</button>
      }
      @if (this.isRepeat) {
        <h2 class='header'>Select additional dates</h2>
      }
      @if (this.isRepeat) {
        <span>Click on the datepicker below to select additional dates, you may select between months.</span>
      }
      <div id="datepicker" data-language='en'  data-multiple-dates="true" [hidden]='!this.isRepeat'></div>
      <br />
      <br />
    }
  </app-tab>


  <app-tab title="Customer Details" [invalid]="!this.isTabComplete('customer')">

    @if (!this.newCustomer) {
      <h3>Select a customer</h3>
      <ng-select [(ngModel)]="this.order.accountId" (change)='this.order.accountId = +$event; this.showCustomerForm = true;loadAccount()'>
        @for (item of this.accounts; track item) {
          <ng-option [value]='item.id'>{{ item.name }}</ng-option>
        }
      </ng-select>
    }

    <br />
    @if (!this.newCustomer) {
      <button class="btn btn-primary"  (click)="addCustomer()">Add a new customer</button>
    }
    <br />

    <ng-container>
      @if (this.newCustomer) {
        <h3>Create a new Customer</h3>
      }
      @if (this.showCustomerForm) {
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>Customer Name</label>
            <input [class.is-invalid]="!this.order.account.name || this.order.account.name === ''" class='form-control' [readonly]="!this.newCustomer" [(ngModel)]="this.order.account.name" />
          </div>
          <div class="form-group col-md-4">
            <label>Account Ref</label>
            <input [class.is-invalid]="!this.order.account.accountRef || this.order.account.accountRef === ''" class='form-control' [readonly]="!this.newCustomer" [(ngModel)]="this.order.account.accountRef" />
          </div>
        </div>
      }

      @if (this.showCustomerForm) {
        <div class="row">
          <div class="col">
            <h3>Address</h3>
            <div class="form-group">
              <label for="billing1">Address Line 1</label>
              <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.billingAddress1' class="form-control" id="billing1">
            </div>
            <div class="form-group">
              <label for="billing2">Address Line 2</label>
              <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.billingAddress2' class="form-control" id="billing2">
            </div>
            <div class="form-group">
              <label for="billing3">City</label>
              <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.billingCity' class="form-control" id="billing3">
            </div>
            <div class="form-group">
              <label for="billing4">Country</label>
              <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.billingCountry' class="form-control" id="billing4">
            </div>
            <div class="form-group">
              <label for="billing5">Postcode</label>
              <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.billingPostCode' class="form-control" id="billing5">
              @if (this.newCustomer) {
                <app-address-picker [postcode]='this.order.account.billingPostCode' (onAddressFound)='this.foundBillingAddress($event)'></app-address-picker>
              }
            </div>
            @if (this.newCustomer) {
              <div class="row">
                <div class="col">
                  <!-- <button class='btn btn-block btn-info' (click)='transferAddress()'>Transfer Address Details to Shipping</button> -->
                </div>
              </div>
            }
          </div>
          <!-- <div class="col">
          <h3>Shipping</h3>
          <div class="form-group">
            <label for="ship1">Address Line 1</label>
            <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.shippingAddress1' class="form-control" id="ship1">
          </div>
          <div class="form-group">
            <label for="ship2">Address Line 2</label>
            <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.shippingAddress2' class="form-control" id="ship2">
          </div>
          <div class="form-group">
            <label for="ship3">City</label>
            <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.shippingCity' class="form-control" id="ship3">
          </div>
          <div class="form-group">
            <label for="ship4">Country</label>
            <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.shippingCountry' class="form-control" id="ship4">
          </div>
          <div class="form-group">
            <label for="ship5">Postcode</label>
            <input type="text" name='name' [readonly]="!this.newCustomer" [(ngModel)]='this.order.account.shippingPostCode' class="form-control" id="ship5">
            <app-address-picker *ngIf="this.newCustomer" [postcode]='this.account.shippingPostCode' (onAddressFound)='this.foundShippingAddress($event)'></app-address-picker>
          </div>
        </div> -->
      </div>
    }
  </ng-container>
</app-tab>
<app-tab title="Site Details" [invalid]="!this.isTabComplete('site')">

  @if (!this.newSite) {
    <h3>Select a site</h3>
    <ng-select [(ngModel)]="this.order.siteId" (change)='this.order.siteId = +$event; this.showSiteForm = true;loadSite()'>
      @for (item of this.sites; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  }

  <br />
  @if (!this.newSite) {
    <button class="btn btn-primary"  (click)="addSite()">Add a new site</button>
  }
  <br />

  <ng-container>
    @if (this.newSite) {
      <h3>Create a new site</h3>
    }
    @if (this.showSiteForm) {
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Site Name</label>
          <input [class.is-invalid]="!this.order.site.name || this.order.site.name === ''" class='form-control' [readonly]="!this.newSite" [(ngModel)]="this.order.site.name" />
        </div>
      </div>
    }

    @if (this.showSiteForm) {
      <div class="row">
        <div class="col">
          <h3>Address</h3>
          <div class="form-group">
            <label for="billing1">Address Line 1</label>
            <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.billingAddress1' class="form-control" id="billing1">
          </div>
          <div class="form-group">
            <label for="billing2">Address Line 2</label>
            <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.billingAddress2' class="form-control" id="billing2">
          </div>
          <div class="form-group">
            <label for="billing3">City</label>
            <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.billingCity' class="form-control" id="billing3">
          </div>
          <div class="form-group">
            <label for="billing4">Country</label>
            <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.billingCountry' class="form-control" id="billing4">
          </div>
          <div class="form-group">
            <label for="billing5">Postcode</label>
            <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.billingPostCode' class="form-control" id="billing5">
            @if (this.newSite) {
              <app-address-picker [postcode]='this.order.site.billingPostCode' (onAddressFound)='this.foundSiteBillingAddress($event)'></app-address-picker>
            }
          </div>
          @if (this.newSite) {
            <div class="row">
              <div class="col">
                <!-- <button class='btn btn-block btn-info' (click)='transferSiteAddress()'>Transfer Address Details to Shipping</button> -->
              </div>
            </div>
          }
        </div>
        <!-- <div class="col">
        <h3>Shipping</h3>
        <div class="form-group">
          <label for="ship1">Address Line 1</label>
          <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.shippingAddress1' class="form-control" id="ship1">
        </div>
        <div class="form-group">
          <label for="ship2">Address Line 2</label>
          <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.shippingAddress2' class="form-control" id="ship2">
        </div>
        <div class="form-group">
          <label for="ship3">City</label>
          <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.shippingCity' class="form-control" id="ship3">
        </div>
        <div class="form-group">
          <label for="ship4">Country</label>
          <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.shippingCountry' class="form-control" id="ship4">
        </div>
        <div class="form-group">
          <label for="ship5">Postcode</label>
          <input type="text" name='name' [readonly]="!this.newSite" [(ngModel)]='this.order.site.shippingPostCode' class="form-control" id="ship5">
          <app-address-picker *ngIf="this.newSite" [postcode]='this.order.site.shippingPostCode' (onAddressFound)='this.foundSiteShippingAddress($event)'></app-address-picker>
        </div>
      </div> -->
    </div>
  }
</ng-container>
</app-tab>
<app-tab title="Tip Details" [invalid]="!this.isTabComplete('tipSite')">
  @if (!this.newTipSite) {
    <h3>Select a tip</h3>
    <ng-select [(ngModel)]="this.order.tipSiteId" (change)='this.order.tipSiteId = +$event; this.showTipForm = true;loadTipSite()'>
      @for (item of this.tips; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  }

  <br />
  @if (!this.newTipSite) {
    <button class="btn btn-primary"  (click)="addTipSite()">Add a new tip site</button>
  }
  <br />

  <ng-container>
    @if (this.newTipSite) {
      <h3>Create a new tip site</h3>
    }
    @if (this.showTipForm) {
      <div class="form-row">
        <div class="form-group col-md-4">
          <label>Tip Name</label>
          <input [class.is-invalid]="!this.order.tipSite.name || this.order.tipSite.name === ''" class='form-control' [readonly]="!this.newTipSite" [(ngModel)]="this.order.tipSite.name" />
        </div>
      </div>
    }

    @if (this.showTipForm) {
      <div class="row">
        <div class="col">
          <h3>Address</h3>
          <div class="form-group">
            <label for="billing1">Address Line 1</label>
            <input type="text" name='name'  [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.billingAddress1' class="form-control" id="billing1">
          </div>
          <div class="form-group">
            <label for="billing2">Address Line 2</label>
            <input type="text" name='name'  [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.billingAddress2' class="form-control" id="billing2">
          </div>
          <div class="form-group">
            <label for="billing3">City</label>
            <input type="text" name='name'  [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.billingCity' class="form-control" id="billing3">
          </div>
          <div class="form-group">
            <label for="billing4">Country</label>
            <input type="text" name='name'  [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.billingCountry' class="form-control" id="billing4">
          </div>
          <div class="form-group">
            <label for="billing5">Postcode</label>
            <input type="text" name='name'  [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.billingPostCode' class="form-control" id="billing5">
            @if (this.newTipSite) {
              <app-address-picker [postcode]='this.order.tipSite.billingPostCode' (onAddressFound)='this.foundTipBillingAddress($event)'></app-address-picker>
            }
          </div>
          @if (this.newTipSite) {
            <div class="row">
              <div class="col">
                <!-- <button class='btn btn-block btn-info' (click)='transferTipAddress()'>Transfer Address Details to Shipping</button> -->
              </div>
            </div>
          }
        </div>
        <!-- <div class="col">
        <h3>Shipping</h3>
        <div class="form-group">
          <label for="ship1">Address Line 1</label>
          <input type="text" name='name' [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.shippingAddress1' class="form-control" id="ship1">
        </div>
        <div class="form-group">
          <label for="ship2">Address Line 2</label>
          <input type="text" name='name' [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.shippingAddress2' class="form-control" id="ship2">
        </div>
        <div class="form-group">
          <label for="ship3">City</label>
          <input type="text" name='name' [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.shippingCity' class="form-control" id="ship3">
        </div>
        <div class="form-group">
          <label for="ship4">Country</label>
          <input type="text" name='name' [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.shippingCountry' class="form-control" id="ship4">
        </div>
        <div class="form-group">
          <label for="ship5">Postcode</label>
          <input type="text" name='name' [readonly]="!this.newTipSite" [(ngModel)]='this.order.tipSite.shippingPostCode' class="form-control" id="ship5">
          <app-address-picker *ngIf="this.newTipSite" [postcode]='this.order.tipSite.shippingPostCode' (onAddressFound)='this.foundTipShippingAddress($event)'></app-address-picker>
        </div>
      </div> -->
    </div>
  }
</ng-container>
</app-tab>

<app-tab title='Pricing' [invalid]="this.orderLines.orderLines.length === 0">
  <br />
  <br />
  <br />
  <br />

  <ng-container>
    <h3>Prices</h3>

    <button type='button' class='btn btn-secondary' (click)='this.openModal("orderCustomItemModal")'><i class="fas fa-plus"></i> Add Rate</button>

    <br />
    <br />

    <table class="table">
      <thead>
        <th>Name</th>
        <th>Qty</th>
        <th>Unit</th>
        <th>Base Price(&pound;)</th>
        <th>Total Price(&pound;)</th>
        <th></th>
      </thead>
      <tbody>
        @for (orderLine of this.orderLines.orderLines; track orderLine) {
          <tr>
            <td><input class='form-control' type='text' [(ngModel)]="orderLine.name"></td>
            <td><input class='form-control' type='number' [(ngModel)]='orderLine.qty' [readOnly]='isTipperEdit()'></td>
            <td>
              <select class='form-control' (change)='orderLine.unitId = +$event.target.value' [readOnly]='isTipperEdit()'>
                @for (unit of this.units; track unit) {
                  <option [selected]='unit.id === orderLine.unitId' [value]='unit.id'>{{ unit.name }}</option>
                }
              </select>
            </td>
            <td><input class='form-control' type='number' [(ngModel)]="orderLine.price"></td>
            <td>{{ orderLine.price * orderLine.qty }}</td>
            <td>
              <input type='checkbox'   [(ngModel)]="orderLine.isPrimaryCharge"
                [ngModelOptions]="{standalone: true}" />&nbsp;
                Is Primary Charge?
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-container>

  </app-tab>

  <app-tab title='Other Charges'>

    <button class='btn btn-secondary' type='button' (click)='this.openModal("orderMaterialUpliftModal")'><i class="fas fa-plus"></i> Add Material Uplift charge</button>&nbsp;&nbsp;

    <br />
    <br />
    <div class='row'>
      <div class='col-md-4'>
        <label>Employee wage cost</label>
        <input type='number' class='form-control' [(ngModel)]="this.order.employeeWageCost" />
      </div>
    </div>
    <br />
    <br />

    <h3>Material Uplift Charges</h3>
    <table class='table'>
      <thead>
        <th>Account</th>
        <th>Name</th>
        <th>Unit</th>
        <th>Qty</th>
        <th>Price</th>
      </thead>
      <tbody>
        @for (uplift of this.materialUplifts.materialUplifts; track uplift) {
          <tr>
            <td><ng-select [(ngModel)]="uplift.accountId" (change)='uplift.accountId= +$event; setAccount();'>
              @for (item of this.accounts; track item) {
                <ng-option [value]='item.id'>{{ item.name }}</ng-option>
              }
            </ng-select></td>
            <td><input class='form-control' type='text' [(ngModel)]="uplift.name" /></td>
            <td><select class='form-control' (change)='uplift.unitId = +$event.target.value'>
              @for (unit of this.units; track unit) {
                <option [value]='unit.id' [selected]='unit.id === uplift.unitId'>{{ unit.name }}</option>
              }
            </select>
            <td><input class='form-control' type='number' [(ngModel)]="uplift.qty" /></td>
            <td><input class='form-control' type='number' [(ngModel)]="uplift.price" /></td>
          </tr>
        }
      </tbody>
    </table>
  </app-tab>
  <!--
  <app-tab title='Site Contact Details' [invalid]="!this.isTabComplete('contact')">
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Company Name</label>
        <input type="text" name='name' [(ngModel)]='this.order.companyName' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Name</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactName' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Telephone</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactTelephone' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Email</label>
        <input type="email" name='name' [(ngModel)]='this.order.contactEmail' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Address Line 1</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine1' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Address Line 2</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine2' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Address Line 3</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactAddressLine3' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact City</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactCity' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Contact Country</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactCountry' class="form-control">
      </div>
      <div class="form-group col-md-4">
        <label>Site Contact Postcode</label>
        <input type="text" name='name' [(ngModel)]='this.order.contactPostCode' class="form-control">
        <app-address-picker [postcode]='this.order.contactPostCode' (onAddressFound)='this.foundContactAddress($event)'></app-address-picker>

      </div>
    </div> -->

    <!-- if skip and not saved allow sending of confirmation email
    <div class='form-row' *ngIf='this.order.orderTypeId === 1 && this.order.id === -1'>
      <div class='form-group'>
        <label>Send confirmation email?</label>
        <input type='checkbox'
          [(ngModel)]="this.order.sendConfirmationEmail"
          [ngModelOptions]="{standalone: true}"/>
      </div>
    </div>

  </app-tab> -->



  @if (this.order.id > 0) {
    <app-tab title='History'>
      <table class="table">
        <thead>
          <th>Person</th>
          <th>Status</th>
          <th>Message</th>
          <th>When</th>
        </thead>
        <tbody>
          @for (item of this.history; track item) {
            <tr>
              <td>{{ item.createdBy === -1 ? 'System' : item.user.firstName + ' ' + item.user.lastName }}</td>
              <td>{{ item.orderStatus.name }}</td>
              <td>{{ item.notes }}</td>
              <td>{{ item.createdAt }}</td>
            </tr>
          }
        </tbody>
      </table>
    </app-tab>
  }
  @if (this.order.id !== -1) {
    <app-tab title='Discussion'>
      <app-discussion [data]='this.order' entity='order'></app-discussion>
    </app-tab>
  }
</app-tabs>
